'use strict';Object.defineProperty(exports,'__esModule',{value:!0});/**
 * Transition-end mapping
 */var map={WebkitTransition:'webkitTransitionEnd',MozTransition:'transitionend',OTransition:'oTransitionEnd',msTransition:'MSTransitionEnd',transition:'transitionend'},EL,RESULT;exports.default=function(){if(EL||(EL=document.createElement('p')),RESULT)return RESULT;for(var a in map)if(null!=EL.style[a]){RESULT=map[a];break}return RESULT};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-tab-panel/lib/getTransitionEnd.js
 ** module id = 2072
 ** module chunks = 0
 **/